<mat-dialog-actions>
    <span class="closebuttonspan" mat-dialog-close mat-icon-button aria-label="close dialog" (click)="clickclose()">
        <i class="closebutton fa-solid fa-circle-xmark" (click)="clickclose()"></i>

    </span>
</mat-dialog-actions>
<div md-dialog-content class="mat-dialog-content">{{data.alertMessage}}</div>
<!-- <div md-dialog-actions class="mat-dialog-actions">

    <button class="dialogbutton" md-button (click)="dialogRef.close(false)">Close</button>
</div> -->